var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sports-page" },
    [
      _c(
        "v-layout",
        { staticClass: "page-layout" },
        [
          _c(
            "v-flex",
            {
              ref: "maincolumn",
              staticClass: "main-column",
              style: { paddingTop: _vm.headerHeight + "px" }
            },
            [
              _c("resize-observer", { on: { notify: _vm.mainColumnResize } }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "page-content account",
                  class: { loggedIn: _vm.isLoggedIn }
                },
                [
                  _vm.brandTemplate !== "generic_2" &&
                  _vm.isLoggedIn &&
                  _vm.accountSummaryFlow &&
                  _vm.mobileBigAndBelow
                    ? _c("account-info-summary")
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.tabletAndAbove && _vm.isLoggedIn
                    ? _c(
                        "div",
                        { staticClass: "account_links acc_nav" },
                        [
                          _c("div", { staticClass: "acc_header" }, [
                            _vm._v(_vm._s(_vm.$t("Account.PlayerZone")))
                          ]),
                          _vm._v(" "),
                          _c("site-navigation", {
                            staticClass: "account_links",
                            attrs: { "navigation-section": _vm.AccountFlow }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "accpage",
                      class: [
                        _vm.state,
                        {
                          loggedIn: _vm.isLoggedIn,
                          acc_summary_flow: _vm.accountSummaryFlow
                        }
                      ]
                    },
                    [_c("router-view")],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c6d1eefc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c6d1eefc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/AccountLayout.vue
// module id = null
// module chunks = 